export var ErroresGlobal = []
export var ConsolaXQuery = ""; 
export var datosXML = null; 

export function LimpiarErrores()
{
  ErroresGlobal = []
}